var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"导出","visible":_vm.show,"width":"40%"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('div',[(_vm.isComplete)?[_c('h3',{staticClass:"mb20 f13 f-grey"},[_vm._v(" 组件配置项schema，放在组件包下 schema.json 配置文件中，若不满足可手动修改 ")]),_c('json-viewer',{attrs:{"expand-depth":6,"copyable":{
          copyText: '复制JSON',
          copiedText: '已复制',
          timeout: 1000
        },"boxed":""},model:{value:(_vm.config),callback:function ($$v) {_vm.config=$$v},expression:"config"}})]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }